export enum FeatureType {
  CONNECTOR = 'connector',
  SEGMENT = 'segment',
}

export const geometryToLayerType: Record<string, string> = {
  Polygon: 'fill',
  LineString: 'line',
  Point: 'circle',
};

export const NEUTRAL_COLOR = '	#E0FFFF';
export const COLOR_NAME_TO_HEX: Record<string, string> = {
  red: '#FF0000',
  yellow: '#FFFF00',
  green: '#008000',
  blue: '	#1E90FF',
  neutral: NEUTRAL_COLOR,
};

export const COLOR_NAME_TO_THRESHOLD: Record<string, number[]> = {
  neutral: [-Infinity, -0.000001],
  red: [-0.000001, 0.3],
  yellow: [0.3, 0.7],
  green: [0.7, 1],
  blue: [1, Infinity],
};

export enum ColorMetric {
  PRECISION = 'precision',
  RECALL = 'recall',
  AVERAGE_RECALL_BY_LABEL = 'average-recall-by-label',
}

export const DEFAULT_COLOR_METRIC = ColorMetric.AVERAGE_RECALL_BY_LABEL;

///COLOR_MTERICS = ['precision', 'recall', 'average-recall-by-label'];
